<template active-class="ColumnContainer">
  <div class="ColumnContainer">
    <common ref="common" />
    <div class="ScrollContainer padding-style">
      <!-- <v-row no-gutters>
        <v-col> -->
      <div class="d-flex align-content-start flex-wrap">
        <v-img src="../../assets/unauthorized.svg" :aspect-ratio="1.7" contain>
        </v-img>
      </div>
      <div class="title title-style">Unauthorized</div>
      <div class="title title-style2">Contact Your Administrator</div>
      <v-btn class="mt-5" dark color="#e01c24" block @click="logOut">Logout<v-icon right>mdi-exit-to-app</v-icon></v-btn>
      <!-- </v-col>
      </v-row> -->
    </div>
  </div>
</template>
<script>
import common from "@/components/tools/common";
export default {
  components: { common },
  data() {
    return {};
  },
  mounted() {
    // this.GetOrganizationInfo();
    // this.shareBtnVisible = navigator.canShare;
  },
  watch: {},
  methods: {
    logOut(){
      localStorage.clear();
      location.reload()
    }
  },
};
</script>

<style>
.padding-style {
  padding-top: 150px;
  padding-left: 50px;
  padding-right: 50px;
}
.title-style {
  text-align: center;
  padding: 20px;
}
.title-style2 {
  text-align: center;
  padding-top: 1px;
}
</style>